import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = /\/auth\/(login|refresh|logout)/;
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !NO_RETRY.test(cfg.url || "")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiError(e?.response?.data?.detail) || e.message;

export async function fetchFile(path, params, fallbackName) {
  const res = await api.get(path, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  return { blob: res.data, name: (cd.match(/filename="([^"]+)"/) || [])[1] || fallbackName };
}

export async function fetchReportJob(kind, params, fallbackName) {
  const { data } = await api.post("/report/jobs", { kind, ...params });
  for (;;) {
    await new Promise((r) => setTimeout(r, 2500));
    const { data: st } = await api.get(`/report/jobs/${data.id}`);
    if (st.status === "error") throw new Error(st.error || "Gagal menyusun laporan");
    if (st.status === "done") return fetchFile(`/report/jobs/${data.id}/file`, {}, st.name || fallbackName);
  }
}

export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function download(path, params, fallbackName) {
  const { blob, name } = await fetchFile(path, params, fallbackName);
  saveBlob(blob, name);
}
